import { put } from 'redux-saga/effects';
import { defineJwt } from '../api/config';
import requestLogoutSuccess from '../actions/requestLogoutSuccess';

export default function* unauthorizeSaga() {
    defineJwt('');
    yield put(requestLogoutSuccess());
}
